<template>
  <div>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">基本信息</span>
      </div>
      <SForm
        ref="formref"
        :url="formurl"
        method="post"
        :fields="formfields"
        :data-form="rowdata"
        :before="formbefore"
        :handle="formhandle"
        label-width="90px"
        :inline="false"
        form-style="width: 500px;"
      />
    </el-card>
  </div>
</template>
<script>
export default {
  name: 'ReviseAdministrators',
  components: {},
  data() {
    return {
      formurl: '/user',
      rowdata: {},
      formfields: [
        {
          label: '管理员姓名',
          prop: 'userName',
          poplaceholder: '请输入管理员姓名',
          rules: { required: true, message: '请输入管理员姓名', trigger: 'blur' }
        },
        {
          label: '管理员账号',
          prop: 'loginName',
          disabled: true,
          rules: { required: true, message: '请输入管理员账号', trigger: 'blur' }
        },
        {
          label: '手机',
          prop: 'mobile',
          poplaceholder: '请输入手机号码',
          rules: { required: true, message: '请输入正确的手机号码', pattern: /^1[23456789]\d{9}$/, trigger: 'blur' }
        }
      ],
      formbefore: record => {
        console.log(record)
        const data = {
          id: record.id,
          loginName: record.loginName,
          userName: record.userName,
          mobile: record.mobile
        }
        console.log(data)
        return data
      },
      formhandle: record => {
        this.$router.go(-1)
      }
    }
  },
  computed: {},
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {
    this.rowdata = this.$route.query.data
  }, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

  <style lang="less" src="" scoped></style>



// WEBPACK FOOTER //
// src/views/userManagement/reviseAdministrators.vue